// extracted by mini-css-extract-plugin
export default {"container":"styles_container__CWsW1","loader":"styles_loader__p0Van","animMarker":"styles_animMarker__SoY2W","animShadow":"styles_animShadow__zywNk"};